<template>
  <div class="app-navbar-actions">
    <div v-if="authStore.user?.laboratory" class="lab-info">
      <div class="lab-name">{{ authStore.user.laboratory.full_name }}</div>
    </div>
    <NotificationDropdown class="app-navbar-actions__item" />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile" />
  </div>
</template>

<script lang="ts" setup>
import { useHemocultureAuthStore } from '../../../stores/hemoculture-auth'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const authStore = useHemocultureAuthStore()
</script>

<style lang="scss" scoped>
.app-navbar-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  height: 100%;
  margin-right: 0;
  padding-right: 0;

  @media screen and (max-width: 768px) {
    gap: 0.5rem;
  }

  .lab-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    height: 100%;
    padding: 0 1.2rem 0 1rem;
    border-right: 1px solid rgba(15, 23, 42, 0.12);
    gap: 0.15rem;

    @media screen and (max-width: 1024px) {
      padding: 0 0.9rem 0 0.75rem;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }

    .lab-name {
      font-size: 0.8rem;
      font-weight: 600;
      color: #0f172a;
      line-height: 1;
      letter-spacing: -0.01em;
    }

    .lab-sigle {
      font-size: 0.7rem;
      font-weight: 500;
      color: #64748b;
      text-transform: uppercase;
      letter-spacing: 0.06em;
      line-height: 1;
    }
  }

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    height: 100%;

    &:hover {
      transform: translateY(-2px);
    }
  }

  &__item {
    padding: 0;
    margin-left: 0;
    margin-right: 0;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    height: 100%;

    svg {
      height: 18px;
      width: 18px;
      transition: all 0.3s ease;

      @media screen and (max-width: 768px) {
        height: 16px;
        width: 16px;
      }
    }

    &--profile {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    :deep(.va-dropdown-content) {
      background-color: var(--va-white);
    }

    &:hover svg {
      transform: scale(1.1);
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: inherit;
    height: 100%;

    > * {
      transition: all 0.3s ease;
      display: flex;
      align-items: center;
      height: 100%;

      &:hover {
        transform: translateY(-2px);
      }
    }
  }
}
</style>
